import { HttpParams } from '@angular/common/http';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { ListingBaseComponent } from 'src/app/shared/components/base/listing-base.component';
import { PurplWallet } from 'src/app/shared/interfaces/Wallets';

@Component({
  selector: 'app-generic-partner-dashboard-nc',
  templateUrl: './generic-partner-dashboard-nc.component.html',
  styleUrls: ['./generic-partner-dashboard-nc.component.scss'],
})
export class GenericPartnerDashboardNcComponent
  extends ListingBaseComponent
  implements OnInit
{
  @Input() wallets: PurplWallet[] = [];
  @Input() URL_CASH_OUT: string = '';
  @Input() URL_USERS_COUNT: string = '';
  @Input() depositLabel: string = '';
  @Input() DEPOSITS_AMOUNT: string = '';
  @Input() TOTAL_FUNDS: string = '';

  CASH_OUT_COMPLETED?: number;
  USERS_COUNT?: number;
  params: HttpParams = new HttpParams();

  view: any[] = [280, 280];
  colorScheme: any;

  colorFunds: any = {
    domain: ['#808E9E', '#66023C', '#C7CED7'],
  };

  colorFunds2: any = {
    domain: ['#66023C', '#808E9E', '#C7CED7'],
  };

  filterValue: string = 'last_30_days';

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    this.colorScheme = this.colorFunds;
  }
}
